module.exports = __webpack_public_path__ + "static/media/20ECE6.ed6d5b38.jpg";